import { FC, useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'

import { Memo } from '@/hoc/Memo'
import { LayoutApp } from '@/layout/LayoutApp'
import { useAppDispatch } from '@/core/store/hooks'
import { changeAuth } from './AccountPage/store/accont.slice'

// Pages
import { LoginPage } from './LoginPage'
import { RegistrationPage } from './RegistrationPage'
import { VerificationPage } from './VerificationPage'
import { ErrorPage } from './ErrorPage'
import { ForgotPassword } from './ForgotPassword/ForgotPassword'
import { CompleteRecovering } from './CompleteRecovering'
import { PrivacyPage } from './PrivacyPage'
import { TermsPage } from './TermsPage'

import { PrivateAppPage } from './PrivateApp'
import { parse } from 'query-string'
import { setItem } from '@/utils/persistanceStorage'

export const RegistrationApp: FC = Memo(() => {
  const { pathname, search } = useLocation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const str = parse(search)
    const companyCode = (str.companyCode as string) || null
    if (companyCode) {
      setItem('companyCode', companyCode, false)
    }
  }, [search])

  useEffect(() => {
    if (pathname && pathname.indexOf('/cabinet/') === -1) {
      localStorage.removeItem('token')
      localStorage.removeItem('form')
      dispatch(changeAuth(false))
    }
  }, [pathname])

  return (
    <LayoutApp>
      <Routes>
        <Route path='/' element={<LoginPage />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/registration' element={<RegistrationPage />} />
        <Route path='/verification' element={<VerificationPage />} />
        <Route path='/cabinet/*' element={<PrivateAppPage />} />
        <Route path='/recovering' element={<CompleteRecovering />} />
        <Route path='/privacy' element={<PrivacyPage />} />
        <Route path='/terms' element={<TermsPage />} />
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </LayoutApp>
  )
})
